import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { OutlineDarkLightAlerts } from "../../../../Constant";
import { OUTLINE_LIGHT_DATA } from "../../../../Data/UiKit/Alert";
import { Clock, ThumbsUp } from "react-feather";
import { Alerts, Btn, P } from "../../../../AbstractElements";
import { useState } from "react";

const OutlineDarkAndLightAlerts = () => {
  const [visible, setVisible] = useState(true);
  const [visibleAlert, setVisibleAlert] = useState(true);
  const onDismiss = () => setVisible(false);
  const onDismissAlert = () => setVisibleAlert(false);

  return (
    <Col sm="12" xl="6">
      <Card>
        <CommonCardHeader title={OutlineDarkLightAlerts} span={OUTLINE_LIGHT_DATA} />
        <CardBody>
          <Alerts color="" isOpen={visible} className="txt-primary border-primary alert-dismissible">
            <Clock />
            <P>One of <strong>YouTube's</strong> most crucial ranking factors is Watch Time.</P>
            <Btn className="btn-close" onClick={onDismiss}></Btn>
          </Alerts>
          <Alerts isOpen={visibleAlert} className="txt-success border-success outline-2x alert-dismissible alert-icons">
            <ThumbsUp />
            <P><b> Well done! </b>You successfully read this important message.</P>
            <Btn className="btn-close" onClick={onDismissAlert}></Btn>
          </Alerts>
        </CardBody>
      </Card>
    </Col>
  );
};

export default OutlineDarkAndLightAlerts;
